import { render, staticRenderFns } from "./textStart.vue?vue&type=template&id=22682ba7&"
import script from "./textStart.vue?vue&type=script&lang=ts&"
export * from "./textStart.vue?vue&type=script&lang=ts&"
import style0 from "./textStart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports